export interface GroupListResource {
  id: number;
  name: string;
  roleName: string;
}

export interface GroupResource {
  id: number;
  name: string;
  role: GroupRoleResource;
}

export interface GroupRoleResource {
  id: number;
  name: string;
}

export class SaveGroupRequest {
  id?: number = null;
  name: string;
  roleId: number;

  get isNew() {
    return this.id === null;
  }
}

export interface SaveGroupResponse {
  id: number;
}
